export const SET_ONBOARDING_STEP = 'onboarding/SET_ONBOARDING_STEP';
export const SET_ONBOARDING_FINISHED = 'onboarding/SET_ONBOARDING_FINISHED';
export const STEP_NUMS = {
    SOURCES: 0,
    TOPICS: 1,
    ABOUT_YOU: 2,
    DONE: 3,
};
export const MINIMUM_SELECTED_ITEM_COUNT = 3;
